import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * 旧路由保链：设计模板已迁入建站工具，改名「设计参考」。
 * /design-templates → /site-tools/references
 */
export const Route = createFileRoute("/_protected/design-templates/")({
  beforeLoad: () => {
    throw redirect({ to: "/site-tools/references" });
  },
});
